import { useContext } from "react";
import { AuthenticatedUserContext } from "./AuthenticatedUserContext";

/**
 * retrieves the current logged in user if logged in from context
 **/
export const useAuthenticatedUserContext = () => useContext(AuthenticatedUserContext);
